import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IRouteNormalized } from '../../../types';

const SidebarItem: FC<IRouteNormalized> = (props) => {

  const {
    path,
    titleNav,
  } = props;

  return (
    <li>
      <Link to={path} className="navbar-item">
        {titleNav}
      </Link>
    </li>
  );

};

export default SidebarItem;
